import store from "../../config/store";
import { SiafLiteApiStream } from "../../external";
import SiafLiteApiRepository from "../../external/siafLiteApi";

class NfEntradaService {
  constructor() {
    this.urlBase = "/estoque/nf-entrada";
    this.urlBaseEvent = `/event${this.urlBase}`;
    this.urlBaseCompleta = `${store.baseUrl}${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getVinculoOperacaoFiscal(operacaoFiscalId) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${operacaoFiscalId}/vinculo-operacao-fiscal`
    ).get();
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  remover(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  transferencia(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/transferencia`).post(
      body
    );
  }

  getRelatorioResumido(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/resumido`
    ).path(body);
  }

  getRelatorioPrecificacao(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/precificacao`
    ).path(body);
  }
}

export default NfEntradaService;
